import { ListGroup } from 'react-bootstrap';

import ITaskHistory from '../types/Task/TaskHistory';

type Props = {
    preloadedHistorys: ITaskHistory[];
};

export default function TaskHistory({ preloadedHistorys }: Props) {
    return (
        <div className="list-group" id="ideaHistorySection">
            <ListGroup>
                {preloadedHistorys.map((history, i) => {
                    let changedFrom = '';
                    let wordTo = '';
                    let fieldName = history.fieldName;

                    if (history.oldValue) {
                        changedFrom = 'changed from';
                        wordTo = ' to ';
                    } else {
                        if (history.fieldName === 'Assigned To' && !history.oldValue) {
                            fieldName = 'Claimed By';
                        } else if (history.fieldName === 'Submission') {
                            fieldName = '';
                        } else if (history.fieldName === 'Added New File') {
                            changedFrom = 'with a file name of';
                        } else {
                            changedFrom = 'set to';
                        }
                    }

                    const historyDate = new Date(history.modifiedDate);
                    return (
                        <ListGroup.Item key={i}>
                            <p className="mb-1 commentListItem">
                                <strong>{fieldName}</strong> {changedFrom} <strong>{history.oldValue}</strong>
                                {wordTo}
                                <strong>{history.newValue}</strong>
                            </p>
                            <div className="d-flex">
                                <small>Modified By: {history.modifiedUser}</small>
                            </div>
                            <div className="d-flex">
                                <small>
                                    {historyDate.toLocaleString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric',
                                        hour: 'numeric',
                                        minute: 'numeric',
                                        hour12: true,
                                        timeZoneName: 'short',
                                    })}
                                </small>
                            </div>
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        </div>
    );
}